import {refreshParentSospeso} from "./sospeso";
import {initFormTab} from "./form_tab";

function createNewCounterpart() {
    const $form = $('form.journal_entry')
    const $partial = $form.find('.has-many-counterpart');
    const $select = $form.find('.select2-counterpart');

    $(document).on('click', '.click-create-counterpart', function () {
        $select.select2('close');
        clearCounterSelect($select)
        clearCounterFields($partial)
        $partial.fadeIn(500, function () {
            $partial.removeClass('hidden')
        });
        initFormTab()
    })

    $select.on('change', function (e) {
        let b = []
        $.each($partial.find("input, select"), function (i, x) {
            b.push($(this).val())
        })
        let a = b.flat()

        const $documentTypeSelect = $('form.journal_entry #journal_entry_document_type_id')
        refreshParentSospeso($documentTypeSelect.val())
        if ($(this).val()) {
            $partial.fadeOut(500, function () {
                $partial.addClass('hidden')
                initFormTab()
            });
            clearCounterFields($partial)
        } else if ($partial.find(".field_with_errors").length > 0 || a.filter(n => n).length > 0) { // presente un campo valorizzato
            $partial.removeClass('hidden')
        } else {
        }
        initFormTab()
    })

    $select.trigger('change')
}

function clearCounterSelect($select) {
    // $select.find("option:selected").removeAttr('selected');
    // console.log($select.find("option:selected"), $select.val(''))
    $select.val('')
    $select.trigger('change')
}

function clearCounterFields($partial) {
    $partial.find("#journal_entry_counterpart_attributes_name").val('')
    $partial.find("#journal_entry_counterpart_attributes_p_iva").val('')
    const $sel = $partial.find("#journal_entry_counterpart_attributes_counterpart_type_ids")
    $sel.val('')
    $sel.trigger('change')
}

export { createNewCounterpart }